<template>
    <div class="sub_contents complete_glass_page">
        <div class="cont_center complete_glass_center">

            <div class="join_complete_box complete_glass_card">
                <p class="complete_status_badge">가입 완료</p>
                <p class="join_complete_txt">
                    환영합니다! <br>
                    {{ joinCompleteMessage }}
                </p>
                <p v-if="tenantJoinName" class="tenant_join_name">{{ tenantJoinName }}</p>

                <div v-if="showKakaoChannelGuide" class="channel_guide_area">
                    <p class="channel_guide_txt">
                        이벤트 참여를 위해 카카오 채널추가가 필요합니다.
                    </p>
                    <button type="button" class="btn_type2 btn_kakao_channel" @click.prevent="addKakaoChannel">
                        채널추가하기
                    </button>
                </div>

                <div class="btn_join_complete">
                    <!-- <RouterLink to="/" class="btn_type2">홈으로 가기</RouterLink>
                    <RouterLink to="/HFO_LO_001" class="btn_type2">로그인</RouterLink> -->
                    <button type="button" class="btn_type2 btn_close_popup btn_close_action"
                        @click.prevent="closePopup">닫기</button>
                </div>
            </div>

            <!-- <div class="banner_swipe_area">
                <swiper
                    :modules="modules"
                    @swiper="onSwiper"
                    @slideChange="onSlideChange"
                >
                    <swiper-slide>
                        <a href="#"><img src="@/assets/images/banner_img.jpg" alt=""></a>
                    </swiper-slide>
                    <swiper-slide>
                        <a href="#"><img src="@/assets/images/banner_img.jpg" alt=""></a>
                    </swiper-slide>
                    <swiper-slide>
                        <a href="#"><img src="@/assets/images/banner_img.jpg" alt=""></a>
                    </swiper-slide>
                    <swiper-slide>
                        <a href="#"><img src="@/assets/images/banner_img.jpg" alt=""></a>
                    </swiper-slide>
                </swiper>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {
            showKakaoChannelGuide: false,
            joinCompleteMessage: '회원가입이 완료 되었습니다.',
            tenantJoinName: '',
        }
    },
    mounted() {
        this.showKakaoChannelGuide = sessionStorage.getItem('showKakaoChannelGuideOnJoinComplete') === 'Y';
        this.initJoinCompleteMessage();

        const cpsContext = this.getCpsEntryContext();
        if (cpsContext?.targetUrl) {
            // CPS 가입 완료 화면은 사용자 액션 없이 목적지로 자동 이동한다.
            setTimeout(() => {
                this.closePopup();
            }, 250);
        }
    },
    methods: {
        decodeQueryValue(raw) {
            if (typeof raw !== 'string') return '';
            try {
                return decodeURIComponent(raw);
            } catch (_e) {
                return raw;
            }
        },
        initJoinCompleteMessage() {
            const q = this.$route?.query || {};
            const isTenantJoinFlow = q.joinType === 'tenant-link' || !!q.entUuid || !!q.frcUuid;
            if (!isTenantJoinFlow) {
                this.joinCompleteMessage = '회원가입이 완료 되었습니다.';
                this.tenantJoinName = '';
                return;
            }

            this.joinCompleteMessage = '';

            const queryName = this.decodeQueryValue(
                (typeof q.frcName === 'string' ? q.frcName : '') ||
                (typeof q.entName === 'string' ? q.entName : ''),
            ).trim();
            const sessionName = sessionStorage.getItem('foodcon_frc_name') || sessionStorage.getItem('foodcon_ent_name') || '';
            this.tenantJoinName = queryName || sessionName;
        },
        getCpsEntryContext() {
            try {
                const raw = sessionStorage.getItem('cps_entry_context') || localStorage.getItem('cps_entry_context');
                return raw ? JSON.parse(raw) : null;
            } catch (_e) {
                return null;
            }
        },
        addKakaoChannel() {
            try {
                if (typeof window.Kakao === 'undefined' || !window.Kakao?.Channel?.followChannel) {
                    alert('카카오 서비스를 이용할 수 없습니다. 잠시 후 다시 시도해주세요.');
                    return;
                }

                window.Kakao.Channel.followChannel({
                    channelPublicId: '_aFaen'
                });
            } catch (error) {
                console.error('HFO_MB_005: 카카오 채널 추가 오류', error);
                alert('카카오 채널 추가 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
            }
        },
        closePopup() {
            sessionStorage.removeItem('showKakaoChannelGuideOnJoinComplete');

            const cpsContext = this.getCpsEntryContext();

            // ── 혜택존 복귀: returnTo가 있으면 전용 브릿지로 복귀 ──
            const returnTo = (cpsContext && cpsContext.returnTo) || '';
            if (returnTo) {
                // returnTo만 제거 (무한루프 방지), 나머지 context는 유지
                delete cpsContext.returnTo;
                try {
                    const json = JSON.stringify(cpsContext);
                    sessionStorage.setItem('cps_entry_context', json);
                    localStorage.setItem('cps_entry_context', json);
                } catch (_e) {
                    // ignore
                }
                this.$router.push(returnTo);
                return;
            }
            // ── 혜택존 복귀 끝 → 이하 기존 로직 그대로 유지 ──

            const cpsTargetUrl = cpsContext?.targetUrl || '';
            if (cpsTargetUrl) {
                let finalUrl = cpsTargetUrl;
                const ci = cpsContext?.ci || '';
                if (ci) {
                    try {
                        const parsed = new URL(finalUrl);
                        parsed.searchParams.set('ci', ci);
                        finalUrl = parsed.toString();
                    } catch (_e) {
                        // ignore malformed URL and fallback to original
                    }
                }

                try {
                    // 일부 팝업 환경에서는 현재 창 이동보다 opener 이동이 더 안정적이다.
                    if (window && window.opener && !window.opener.closed) {
                        window.opener.location.href = finalUrl;
                        sessionStorage.removeItem('cps_entry_context');
                        localStorage.removeItem('cps_entry_context');
                        window.close();
                        return;
                    }
                } catch (_e) {
                    // opener 접근 실패 시 현재 창 이동으로 폴백
                }

                sessionStorage.removeItem('cps_entry_context');
                localStorage.removeItem('cps_entry_context');
                window.location.href = finalUrl;
                return;
            }

            const q = this.$route?.query || {};
            const hasTenantTargetMarketingContext = !!(
                q.frcUuid ||
                q.entUuid ||
                q.enUuid ||
                cpsContext?.frcUuid ||
                cpsContext?.entUuid ||
                cpsContext?.enUuid ||
                sessionStorage.getItem('foodcon_frc_uuid') ||
                sessionStorage.getItem('foodcon_ent_uuid') ||
                sessionStorage.getItem('frcUuid') ||
                sessionStorage.getItem('entUuid') ||
                localStorage.getItem('foodcon_frc_uuid') ||
                localStorage.getItem('foodcon_ent_uuid') ||
                localStorage.getItem('frcUuid') ||
                localStorage.getItem('entUuid')
            );

            if (q.source === 'foodcon-crm' || hasTenantTargetMarketingContext) {
                const entUuid = String(
                    q.entUuid ||
                    q.enUuid ||
                    cpsContext?.entUuid ||
                    cpsContext?.enUuid ||
                    sessionStorage.getItem('foodcon_ent_uuid') ||
                    sessionStorage.getItem('entUuid') ||
                    localStorage.getItem('foodcon_ent_uuid') ||
                    localStorage.getItem('entUuid') ||
                    ''
                ).trim();
                const frcUuid = String(
                    q.frcUuid ||
                    cpsContext?.frcUuid ||
                    sessionStorage.getItem('foodcon_frc_uuid') ||
                    sessionStorage.getItem('frcUuid') ||
                    localStorage.getItem('foodcon_frc_uuid') ||
                    localStorage.getItem('frcUuid') ||
                    ''
                ).trim();

                const welcomeUrl = new URL('http://www.foodcon.co.kr/welcome.html');
                if (entUuid) {
                    welcomeUrl.searchParams.set('entUuid', entUuid);
                } else if (frcUuid) {
                    welcomeUrl.searchParams.set('frcUuid', frcUuid);
                }

                window.location.href = welcomeUrl.toString();
                return;
            }

            try {
                // If this page was opened as a popup (window.open), close it.
                if (window && window.opener) {
                    window.close();
                    return;
                }
            } catch (e) {
                console.warn('closePopup error', e);
            }
            // Fallback: navigate to home in non-popup contexts
            this.$router.push('/');
        }
    }
}
</script>

<style scoped>
.sub_contents {
    min-height: calc(100dvh - 65px);
    display: flex;
    align-items: center;
    padding-top: 8px !important;
    padding-bottom: 8px;
    box-sizing: border-box;
}

.cont_center {
    width: 100%;
}

.complete_status_badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 14px;
    padding: 4px 14px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.03em;
    color: #7a5600;
    background: #ffefc2;
}

.join_complete_box {
    max-width: 520px;
    margin: 0 auto;
    padding: 44px 28px 34px;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 18px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
    text-align: center;
}

.join_complete_box .join_complete_txt {
    margin: 0;
    padding-bottom: 0 !important;
    background-image: none !important;
    background-size: 0 !important;
    font-size: 42px;
    font-weight: 700;
    line-height: 1.28;
    color: #2d2d2d;
    letter-spacing: -0.02em;
}

.tenant_join_name {
    margin-top: 14px;
    font-size: 22px;
    font-weight: 700;
    color: #3a3a3a;
    line-height: 1.35;
    word-break: keep-all;
}

.channel_guide_area {
    margin-top: 34px;
    padding: 22px 18px;
    border: 1px solid #f1e9bf;
    border-radius: 14px;
    background: #fffbe6;
}

.channel_guide_txt {
    margin-bottom: 14px;
    font-size: 18px;
    color: #3a3a3a;
    font-weight: 600;
    line-height: 1.45;
    text-align: center;
}

.btn_kakao_channel {
    width: 100%;
    max-width: 320px;
    margin: 0 auto;
    background: #FEE500 !important;
    color: #191919 !important;
    border: 1px solid #f2dd4f;
    font-weight: 700;
}

.btn_join_complete {
    margin-top: 20px !important;
    padding: 0 !important;
    background: transparent !important;
    display: flex;
    justify-content: center;
}

.btn_close_action {
    width: 100%;
    max-width: 320px;
    margin: 0 auto;
}

@media (min-width: 1024px) {
    .complete_glass_page {
        position: relative;
        overflow: hidden;
        background:
            radial-gradient(circle at 10% 12%, rgba(255, 195, 52, 0.2), transparent 34%),
            radial-gradient(circle at 88% 84%, rgba(238, 117, 40, 0.1), transparent 40%),
            linear-gradient(180deg, #fffaf0 0%, #f4f4f4 100%);
    }

    .complete_glass_page::before {
        content: "";
        position: absolute;
        inset: 0;
        background-image:
            linear-gradient(rgba(255, 255, 255, 0.14) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255, 255, 255, 0.14) 1px, transparent 1px);
        background-size: 28px 28px;
        pointer-events: none;
        z-index: 0;
    }

    .complete_glass_center {
        position: relative;
        z-index: 1;
        max-width: 980px;
        margin: 0 auto;
        padding: 22px 20px;
    }

    .complete_glass_card {
        border: 1px solid rgba(255, 255, 255, 0.85);
        background: linear-gradient(145deg, rgba(255, 255, 255, 0.88), rgba(255, 255, 255, 0.72));
        box-shadow: 0 24px 58px rgba(0, 0, 0, 0.11);
        backdrop-filter: blur(8px);
    }
}

@media (max-width: 1023px) {
    .sub_contents {
        min-height: calc(100dvh - 60px);
        align-items: center;
        padding-top: 8px !important;
        padding-bottom: 8px;
    }

    .join_complete_box {
        margin-top: 18px;
        padding: 30px 18px 24px;
        border-radius: 14px;
    }

    .join_complete_box .join_complete_txt {
        font-size: 30px;
        line-height: 1.32;
        padding-bottom: 0 !important;
    }

    .tenant_join_name {
        margin-top: 10px;
        font-size: 18px;
    }

    .channel_guide_area {
        margin-top: 24px;
        padding: 16px 14px;
    }

    .channel_guide_txt {
        font-size: 15px;
        margin-bottom: 12px;
    }

    .btn_join_complete {
        margin-top: 14px !important;
    }
}
</style>